<template>
  <div :style="{'display': 'flex', 'justify-content': position ? 'flex-end' : 'flex-start'}">
    <button @click="onClickExcelEvent" class="excel">
      <span v-if="!loading">
        <i class="fa fa-file-excel-o"/>
        Gerar Excel
      </span>
      <div v-else class="loading-btn button-loading">
        <div class="spinner-btn button-spinner">
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
          <div class="rect5"></div>
        </div>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "btnExcel",
  props: {
    position: {
      default: false,
    },
    loading: {
      default: false
    }
  },
  methods: {
    onClickExcelEvent() {
      this.$emit('emit-event-excel')
    }
  }
}
</script>

<style lang="scss" scoped>

.excel {
  display: flex;
  align-items: center;
  color: #FFFFFF;
  background: #2ACC6B;
  border-radius: 4px !important;
  padding: 10px 28.86px;
  border: none;
  transition: .2s;

  span {
    display: flex;
    align-items: center;
  }

  &:hover, &:active {
    background: #08A747;
  }

  i {
    font-size: 20px;
    margin-right: 8px;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/buttons/btnExcel.vue